import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionBarComponent } from './action-bar.component';
import { ActionBarService } from './action-bar.service';
import { PortalModule } from '@angular/cdk/portal';
import { CmxWebComponentsModule } from '@cmx-web-components/angular';

@NgModule({
  declarations: [ActionBarComponent],
  imports: [CommonModule, PortalModule, CmxWebComponentsModule],
  exports: [ActionBarComponent],
})
export class ActionBarModule {
  static forRoot(): ModuleWithProviders<ActionBarModule> {
    return {
      ngModule: ActionBarModule,
      providers: [ActionBarService],
    };
  }
}
